import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import '@shui/core/sh-splash-screen';
import '@shui/core/sh-button';
import '@shui/core/sh-spinner';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('loginButton', { static: false }) loginButton!: ElementRef;
  
  loaderFlag = false;
  private loaderSubscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Check if user is already authenticated
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home']);
      return;
    }
    
    this.loaderSubscription = this.authService.loader$.subscribe((isLoading) => {
      this.loaderFlag = isLoading;
    });
  }

  ngAfterViewInit(): void {
    // Add native event listener for web component
    if (this.loginButton) {
      this.loginButton.nativeElement.addEventListener('click', () => {
        this.onLogin();
      });
    }
  }

  ngOnDestroy(): void {
    this.loaderSubscription.unsubscribe();
  }

  onLogin(): void {
    this.authService.login();
  }
}
